import Typography, { TypographyProps } from '@repo/ui/typography'
import { Fragment } from 'react/jsx-runtime'

import useTranslate from '../../lib/hooks/use-translate'
import { LocaleKeys } from '../../locale/translation-types'

type Props = TypographyProps & {
  translationKey: LocaleKeys
}

const TextBreakWrapper = ({ translationKey, children, ...props }: Props) => {
  const { t } = useTranslate()

  const lines = t(translationKey).split('<br/>')

  return (
    <Typography {...props}>
      {lines.map((line, index) => (
        <Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </Fragment>
      ))}
      {children}
    </Typography>
  )
}

export default TextBreakWrapper
